var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countdown",class:{hidden: !_vm.visible}},[_c('span',{staticClass:"seconds"},[_vm._v(_vm._s(_vm.second))])])}
var staticRenderFns = []

export { render, staticRenderFns }